import { render, staticRenderFns } from "./percurso.vue?vue&type=template&id=f3fa705e&scoped=true&"
import script from "./percurso.vue?vue&type=script&lang=js&"
export * from "./percurso.vue?vue&type=script&lang=js&"
import style0 from "./percurso.vue?vue&type=style&index=0&id=f3fa705e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fa705e",
  null
  
)

export default component.exports